var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:{ 'is-loading': _vm.state === _vm.$const.OAUTH_AWAITING_ACTION },on:{"click":_vm.openOAuthWindow}},[_vm._v(" Review Permissions ")])}
var staticRenderFns = []

export { render, staticRenderFns }